<template>
    <div class="app-layout__trial">
        <span class="app-layout__trial--period">{{ getTrialPeriodHeading }}</span>
        <common-button
            :isDisabled="!$auth.getUser()?.isMasterUser"
            :label="getButtonLabel"
            size="small"
            type="primary"
            @click="$auth.isUserPracticeDemo() ? goToSignup() : toggleBillingPricingModal()"
        ></common-button>
        <span class="app-layout__trial--period">{{ getTrialPeriodSubheading }}</span>
    </div>
</template>

<script>
    import dayjs from 'dayjs'
    import PracticePlanEnum from '@/enums/PracticePlanEnum'
    import { hasActiveTrial, isFreePlanCode, getEffectivePlanCode } from 'services/billingPlanHelpers'

    export default {
        computed: {
            practice() {
                return this.$auth.getPractice() || {}
            },

            isExpiredFree() {
                const code = getEffectivePlanCode(this.practice)
                const isFree =
                    isFreePlanCode(code) ||
                    this.practice.subscription === PracticePlanEnum.NETWORK ||
                    this.practice.subscription === PracticePlanEnum.FREE
                return isFree && !hasActiveTrial(this.practice) && this.practice.subscription !== PracticePlanEnum.TRIAL_PERIOD
            },

            isOnTrial() {
                return this.$auth.isPracticeTrial()
            },

            numberOfDaysLeft() {
                const today = dayjs()
                const trialPeriod = dayjs(this.practice.trialPeriodEnds)
                return Math.ceil(trialPeriod.diff(today, 'day'))
            },

            getButtonLabel() {
                if (this.$auth.isUserPracticeDemo()) {
                    return this.$t('pages.billing.billing.trial.finish_registration')
                }

                if (this.isOnTrial) {
                    return this.$t('pages.billing.billing.trial.go_billing')
                }

                return this.$t('pages.billing.billing.trial.upgrade')
            },

            getTrialPeriodSubheading() {
                if (this.isExpiredFree) {
                    return this.$t('pages.billing.billing.trial.cotninue_recieving')
                }
                return ''
            },

            getTrialPeriodHeading() {
                if (this.$auth.isUserPracticeDemo()) {
                    return this.$t('pages.billing.billing.trial.demo_account')
                }
                if (this.isExpiredFree) {
                    return this.$t('pages.billing.billing.trial.expired')
                }
                const numberOfDays = this.numberOfDaysLeft
                return this.$tc('pages.billing.billing.trial.ending', numberOfDays, {
                    numberOfDays: numberOfDays,
                })
            },
        },

        methods: {
            toggleBillingPricingModal() {
                this.$emit('toggle-billing-pricing-modal')
            },

            goToSignup() {
                this.$emit('toggle-paywall-modal')
            },
        },
    }
</script>
